import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/** NeoUI — consistent "go back" control for non top-level pages. */
const BackButton = ({ className = '', fallback = '/', label = true }) => {
  const navigate = useNavigate();
  const { t } = useTranslation('common');
  const goBack = () => {
    if (window.history.length > 1) navigate(-1);
    else navigate(fallback);
  };
  return (
    <button
      type="button"
      onClick={goBack}
      className={`inline-flex items-center gap-1.5 rounded-full border border-border bg-card/60 px-3 py-1.5 text-xs font-semibold text-muted-foreground transition-colors hover:bg-muted hover:text-foreground ${className}`}
      data-testid="back-button"
      aria-label={t('back')}
    >
      <ArrowLeft className="h-4 w-4" />
      {label && <span>{t('back')}</span>}
    </button>
  );
};

export default BackButton;
